// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/DocTahedroidImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/DocTahedroidImage.tsx");
  import.meta.hot.lastModified = "1717785166158.8877";
}
// REMIX HMR END

import DocTahedroidDefault from "@assets/audit/default.png";
import DocTahedroidApproval from "@assets/audit/approval.png";
import DocTahedroidBoost from "@assets/audit/boost.png";
import DocTahedroidUrgent from "@assets/audit/urgent.png";
import DocTahedroidWaiting from "@assets/audit/waiting.png";
const images = {
  default: DocTahedroidDefault,
  approval: DocTahedroidApproval,
  boost: DocTahedroidBoost,
  urgent: DocTahedroidUrgent,
  waiting: DocTahedroidWaiting
};
export default function DocTahedroidImage({
  variant,
  className
}) {
  return <img src={images[variant]} className={className} alt="Octahedroid" />;
}
_c = DocTahedroidImage;
export const resultMapping = {
  approval: {
    isResult: true,
    image: "approval",
    diagnosisColor: "text-secondary-600",
    speed: {
      title: "Doc. Tahedroid Approves!",
      message: "Bravo! Doc. Tahedroid has diagnosed your site with peak performance health. It's swift, sturdy, and scoring high on every test."
    },
    opengraph: {
      title: "Meta Tags Mastery Achieved!",
      message: "Hats off to you! Doc. Tahedroid gives a round of applause for your well-crafted meta tags. They're ready to make a splendid impression wherever your link lands."
    }
  },
  boost: {
    isResult: true,
    diagnosisColor: "text-warning-800",
    image: "boost",
    speed: {
      title: "Your Website Needs a Boost!",
      message: "Your website's health is okay, but Doc. Tahedroid recommends some fine-tuning. It's crucial not to let minor issues develop into major setbacks. Let's get your website fit and running at full speed."
    },
    opengraph: {
      title: "Meta Tag Tune-Up Needed!",
      message: "Your meta tags are doing well on several fronts, but there's room to sharpen them for peak performance. Ensure your site's metadata is as compelling as its content."
    }
  },
  urgent: {
    isResult: true,
    diagnosisColor: "text-error-600",
    image: "urgent",
    speed: {
      title: "Immediate Action Advised",
      message: "Alarm bells are ringing! Doc. Tahedroid has identified areas of your site that need urgent optimization. It's time to act fast and avert potential crises down the line."
    },
    opengraph: {
      title: "Immediate Action Advised",
      message: "Doc. Tahedroid has detected that your meta tags are not fully optimized for all channels. It's crucial to present a cohesive brand story across social media, search results, and direct messages to achieve business goals."
    }
  },
  waiting: {
    image: "waiting",
    speed: {
      title: "Hang tight, this'll just take a moment",
      message: "Retrieving Google Index data on your website's performance and compiling a purr-fectly detailed report."
    },
    opengraph: {
      title: "Hang tight, this'll just take a moment",
      message: "Retrieving Google Index data on your website's performance and compiling a purr-fectly detailed report."
    }
  },
  waitingFull: {
    image: "waiting",
    speed: {
      title: "Just a meowment! Getting your full report…",
      message: "Preparing your full results. This shouldn’t take long."
    },
    opengraph: {
      title: "Just a meowment! Getting your full report…",
      message: "Preparing your full results. This shouldn’t take long."
    }
  },
  default: {
    image: "default",
    speed: {
      title: "Check your website health",
      message: "Enter your URL to run a comprehensive performance speed test or delve into the intricacies of meta tags."
    },
    opengraph: {
      title: "Check your website health",
      message: "Enter your URL to run a comprehensive performance speed test or delve into the intricacies of meta tags."
    }
  }
};
var _c;
$RefreshReg$(_c, "DocTahedroidImage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;